var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.5C20.2091 3.5 22 5.29086 22 7.5V16.5C22 18.7091 20.2091 20.5 18 20.5H6C3.79086 20.5 2 18.7091 2 16.5V7.5C2 5.29086 3.79086 3.5 6 3.5H18ZM14 8C13.7073 8 13.4318 8.12817 13.2432 8.34668L13.168 8.44531L10 13.1973L8.83203 11.4453C8.64657 11.1671 8.33435 11 8 11H6C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H7.46484L9.16797 15.5547C9.35343 15.8329 9.66565 16 10 16C10.3344 16 10.6466 15.8329 10.832 15.5547L14 10.8027L15.168 12.5547L15.2432 12.6533C15.4318 12.8718 15.7073 13 16 13H18C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11H16.5352L14.832 8.44531C14.6466 8.16711 14.3344 8 14 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashflow);
export default __webpack_public_path__ + "static/media/cashflow.1caeed48365a77eb423fdf0a66c9211a.svg";
export { ForwardRef as ReactComponent };